import { useTranslation } from 'react-i18next';
import { useChatStore } from './chatStore';
import { opsPromptLibrary } from './opsPromptLibrary';

type SuggestedPromptsProps = {
  onPick: (prompt: string) => void;
};

export function SuggestedPrompts({ onPick }: SuggestedPromptsProps) {
  const { t } = useTranslation('chat');
  const messages = useChatStore((s) => s.messages);
  const lastAssistant = [...messages].reverse().find((m) => m.role === 'assistant');
  const suggested = (lastAssistant?.suggestedPrompts ?? [])
    .map((prompt) => prompt.trim())
    .filter(Boolean);
  const prompts = suggested.length > 0 ? suggested : opsPromptLibrary;
  const label = suggested.length > 0 ? t('suggestions') : t('promptLibrary');

  if (!prompts || prompts.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 border-t border-border px-3 py-2">
      <span className="self-center text-[10px] uppercase text-muted-foreground">
        {label}
      </span>
      {prompts.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onPick(p)}
          className="rounded-full border border-border bg-muted/40 px-2 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          {p}
        </button>
      ))}
    </div>
  );
}
